import { useLang } from "@/i18n/LanguageContext";

// Sprachumschalter vorerst ausgeblendet. i18n-System bleibt intakt.
// Auf true setzen, um die DE/EN-Buttons wieder anzuzeigen.
const SHOW_LANGUAGE_TOGGLE = false;

export function LanguageToggle({ compact = false }: { compact?: boolean }) {
  if (!SHOW_LANGUAGE_TOGGLE) return null;
  const { lang, setLang } = useLang();
  const btn = (val: "de" | "en", label: string) => {
    const active = lang === val;
    return (
      <button
        key={val}
        type="button"
        onClick={() => setLang(val)}
        aria-pressed={active}
        style={{
          padding: compact ? "0.2rem 0.55rem" : "0.3rem 0.7rem",
          fontSize: compact ? "0.72rem" : "0.78rem",
          fontWeight: 600,
          borderRadius: 4,
          border: "1px solid " + (active ? "var(--accent-cyan)" : "rgba(255,255,255,0.12)"),
          background: active ? "var(--accent-cyan)" : "transparent",
          color: active ? "#0f0a1a" : "var(--text-muted)",
          cursor: "pointer",
          letterSpacing: "0.04em",
        }}
      >
        {label}
      </button>
    );
  };
  return (
    <div role="group" aria-label="Sprache / Language" style={{ display: "inline-flex", gap: 4 }}>
      {btn("de", "DE")}
      {btn("en", "EN")}
    </div>
  );
}
